module.exports = __webpack_public_path__ + "static/media/400157_01.049e5228.png";